<template>
    <div class="factory-list-table">
        <el-table
            :data="getFactoryList.itens"
            :empty-text="translate('messages.view.no_data')"
            highlight-current-row
        >
            <el-table-column
                width="150px"
                prop="codigoLyra"
                :label="translate('table.lyra_id')"
                label-class-name="factory-list-table_label"
            />
            <el-table-column
                min-width="180px"
                prop="numeroRegistro"
                :label="translate('table.industrial_registration_number')"
                label-class-name="factory-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="warehouse-list_text">
                        {{ validateText(scope.row.numeroRegistro) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="150px"
                prop="numeroDocumento"
                :label="translate('table.ruc')"
                label-class-name="factory-list-table_label"
            />
            <el-table-column
                min-width="180px"
                prop="razaoSocial"
                :label="translate('table.legal_name')"
                label-class-name="factory-list-table_label"
            />
            <el-table-column
                min-width="180px"
                prop="localidadeNivel1"
                :label="translate('table.location')"
                label-class-name="factory-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="warehouse-list_text">
                        {{ scope.row.localidadeNivel2 + " - " + scope.row.localidadeNivel1}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                min-width="180px"
                :label="translate('table.geographic_location')"
                label-class-name="factory-list-table_label"
            >
                <template v-slot:default="scope">
                    <div class="warehouse-list_text">
                        {{ scope.row.latitudeY }}
                    </div>
                    <div class="warehouse-list_text">
                        {{ scope.row.longitudeX }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                width="120px"
                :label="translate('table.actions')"
                align="center"
                label-class-name="factory-list-table_label"
            >
                <template v-slot:default="scope">
                    <el-dropdown
                        class="action-button"
                        trigger="click"
                        @click="scope"
                    >
                        <span class="el-dropdown-link">
                            <i class="mdi mdi-dots-vertical" />
                        </span>
                        <el-dropdown-menu v-slot="dropdown">
                            <el-dropdown-item
                                icon="el-icon-view"
                                @click.native="handleView(scope.row)"
                            >
                                {{ translate('messages.view_industry') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                icon="el-icon-map-location"
                                @click.native="openViewTerritoriesModal(scope.row)"
                            >
                                {{ translate('messages.view.view_territories') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <div class="factory-list-table__pagination">
            <div class="total">
                <span
                    >{{ getFactoryList.totalItens }}
                    {{
                        translate('messages.view.results')
                    }}</span
                >
                <div style="margin: 0 20px"></div>
                <span
                    >{{
                        translate('messages.view.views_by_page')
                    }}:</span
                >
                <el-pagination
                    @size-change="handleSizeChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="sizes"
                    :total="getFactoryList.totalItens"
                />
            </div>
            <div class="prev_next">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="prev, pager, next, jumper"
                    :total="getFactoryList.totalItens"
                />
            </div>
        </div>
        <view-territories-modal
            v-if="showViewTerritoriesModal"
            :show="showViewTerritoriesModal"
            :factory="selectedFactory"
            @close="showViewTerritoriesModal = false"
        />
    </div>
</template>

<script>
import ViewTerritoriesModal from '@/modules/warehouse/views/components/ViewTerritoriesModal.vue';

import { mapActions, mapState, mapGetters } from 'vuex';
import { MainPageTabs } from '@/modules/warehouse/constants/MainPageTabsEnum';

export default {
    name: 'factoryDefault',
    components: {
        ViewTerritoriesModal
    },
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            page: 1,
            size: 10,
            totalElements: 0,
            showViewTerritoriesModal: false,
            selectedFactory: null,
            tabName: MainPageTabs.FACTORIES_TAB
        };
    },
    computed: {
        ...mapState('warehouseModule', ['selectedTab', 'tableLoadControl', 'factoryFilter', 'searchText']),
        ...mapGetters('warehouseModule', ['getFactoryList']),
        filterHandler() {
            return [
                this.factoryFilter.page,
                this.factoryFilter.size,
                this.searchText
            ];
        }
    },
    created() {
        this.$store.commit('warehouseModule/SET_TABLE_CONTROL', {factoryList: false});
    },
    mounted() {
        const newFilter = {
            ...this.factoryFilter,
            page: this.page,
            size: this.size
        };
        this.setFactoryFilter(newFilter);
    },
    watch: {
        selectedTab: {
            handler(newVal) {
                if (this.selectedTab === this.tabName && !this.tableLoadControl.factoryList) {
                    this.getFactories();
                }
            }
        },
        filterHandler() {
            if (this.selectedTab === this.tabName && !this.tableLoadControl.factoryList) {
                this.getFactories();
            }
        }
    },
    methods: {
        ...mapActions('warehouseModule', ['fetchFactories']),
        translate(key, params = {}) {
            const base = 'warehouse';
            return this.$t(`${base}.${key}`, params);
        },
        handleSizeChange(size) {
            this.page = 1;
            this.size = size;
            const newFilter = {
                ...this.factoryFilter,
                page: this.page,
                size: size
            };
            this.$store.commit('warehouseModule/SET_TABLE_CONTROL', {factoryList: false});
            this.setFactoryFilter(newFilter);
        },
        handleCurrentChange(page) {
            this.page = page;
            const newFilter = {
                ...this.factoryFilter,
                page: page,
                size: this.size
            };
            this.$store.commit('warehouseModule/SET_TABLE_CONTROL', {factoryList: false});
            this.setFactoryFilter(newFilter);
        },
        handleView(selected) {
            this.$router.push({
                name: 'VisualizarFabrica',
                params: {
                    factoryId: selected.id,
                    viewPendingOperations: 'transacoes-fabrica',
                    type: 'FACTORY'
                }
            });
        },
        openViewTerritoriesModal(row) {
            this.showViewTerritoriesModal = true;
            this.selectedFactory = row;
        },
        validateText(text) {
            if (!text || text === '') return '-';
            return text;
        },
        getFactories() {
            this.fetchFactories();
            this.$store.commit('warehouseModule/SET_TABLE_CONTROL', {factoryList: true});
        },
        setFactoryFilter(newFilter) {
            this.$store.commit('warehouseModule/SET_FACTORY_FILTER', newFilter);
        }
    }
};
</script>

<style scoped lang="scss">
.factory-list-table {
    margin-top: -8px;
    .el-table {
        border-radius: 5px;
        height: calc(100% - 60px) !important;
        width: 100%;

        .action-button {
            cursor: pointer;
        }
    }
    .factory-list-table__pagination {
        display: grid;
        grid-template-columns: 2fr auto;
        margin: 20px 12px 0;
        @media (max-width: 768px) {
            grid-template-columns: 1fr;
        }

        .total {
            display: flex;
            align-items: center;
            @media (max-width: 768px) {
                flex-direction: column;
            }
        }

        .prev_next {
            display: flex;
            @media (max-width: 768px) {
                justify-content: center;
                margin-top: 20px;
            }
        }
    }
}
.level1-label {
    font-size: 12px;
    color: #7c7c7c !important;
}
::v-deep .factory-list-table_label {
    word-break: keep-all !important;
}
.warehouse-list_text {
    word-break: keep-all !important;
}
</style>
